//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
export default {
  name: 'rb-banner-fields-aside',
  components: {
    RbBanner,
  },
  computed: {
    textAlign() {
      return this.$mq === TABLET || this.$mq === MOBILE ? 'center' : 'left'
    },
  },
}
